import { Button, Modal } from "flowbite-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineCloseCircle } from "react-icons/ai";
import {
    HiOutlineCheckCircle, HiOutlineTrash
} from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert2";
import {
    removeAllProductInCart,
    setCartItemActive
} from "../redux/locationReducer";
import {
    getProductsByFilter,
    getProductTotalCount
} from "../redux/productReducer";
import { openSnackBar } from "../redux/snackBarReducer";
import AddProductInToWineMenu from "./AddProductInToWineMenu";
import CartItem from "./Global/CartItem";
import Loading from "./Global/Loading";

function ProductTable() {
    const { t } = useTranslation();
    const { globalState, locationState } = useSelector((state) => state);

    const { carts, setCartItemActiveState, getProductsByFilterState } =
        locationState;
    const { condition } = globalState;
    // const { company, role } = userInfo;
    const dispatch = useDispatch();

    useEffect(() => { }, []);

    const emptyCart = () => {
        if (carts.length > 0) {
            swal
                .fire({
                    title: t("swal_are_you_sure"),
                    text: t("swal_del_all_product_cart"),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: t("swal_delete"),
                })
                .then(async (result) => {
                    if (result.isConfirmed) {
                        let res = await dispatch(removeAllProductInCart());
                        if (res !== false) {
                            dispatch(
                                openSnackBar({
                                    message: t("msg_success_remove_all_product_cart"),
                                    status: "success",
                                })
                            );
                        }
                    }
                });
        } else {
            dispatch(
                openSnackBar({
                    status: "error",
                    message: "There is no product in basket.",
                })
            );
        }
    };

    const setActive = () => {
        if (carts.length > 0) {
            swal
                .fire({
                    title: t("swal_are_you_sure"),
                    text: t("swal_active_all_product"),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: t("swal_active_all"),
                })
                .then(async (result) => {
                    if (result.isConfirmed) {
                        var activeList = [];
                        carts.map((data, index) => {
                            activeList = [...activeList, data._id];
                        });

                        let res = await dispatch(
                            setCartItemActive({
                                list: activeList,
                                type: true,
                                dozen: "multi",
                                isGlobal: condition.isGlobal,
                                company: condition.company,
                                role: condition.role,
                                user_id: condition.user_id,
                            })
                        );
                        if (res !== false) {
                            dispatch(
                                openSnackBar({
                                    message: `${t("success")} ${t("active")} ${t(
                                        "msg_all_product_cart"
                                    )}`,
                                    status: "success",
                                })
                            );
                            await dispatch(getProductsByFilter(condition));
                            await dispatch(getProductTotalCount(condition));
                        }
                    }
                });
        } else {
            dispatch(
                openSnackBar({
                    status: "error",
                    message: "There is no product in basket.",
                })
            );
        }
    };

    const setInActive = () => {
        if (carts.length > 0) {
            swal
                .fire({
                    title: t("swal_are_you_sure"),
                    text: t("swal_inactive_all_product"),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: t("swal_inactive_all"),
                })
                .then(async (result) => {
                    if (result.isConfirmed) {
                        var inActiveList = [];
                        carts.map((data, index) => {
                            inActiveList = [...inActiveList, data._id];
                        });

                        let res = await dispatch(
                            setCartItemActive({
                                list: inActiveList,
                                type: false,
                                dozen: "multi",
                                isGlobal: condition.isGlobal,
                                company: condition.company,
                                role: condition.role,
                                user_id: condition.user_id,
                            })
                        );
                        if (res !== false) {
                            dispatch(
                                openSnackBar({
                                    message: `${t("success")} ${t("inactive")} ${t(
                                        "msg_all_product_cart"
                                    )}`,
                                    status: "success",
                                })
                            );
                            await dispatch(getProductsByFilter(condition));
                            await dispatch(getProductTotalCount(condition));
                        }
                    }
                });
        } else {
            dispatch(
                openSnackBar({
                    status: "error",
                    message: "There is no product in basket.",
                })
            );
        }
    };

    const [modalShow, setModalShow] = useState(false);

    return (
        <>
            <div className="flex items-center pr-4">
                <div
                    onClick={() => setModalShow(true)}
                    className="w-full font-medium px-2  text-sm inline-flex items-center justify-center border-2 border-transparent rounded-lg leading-5 shadow-sm transition duration-150 ease-in-out bg-indigo-500 hover:!bg-indigo-400 text-white cursor-pointer"
                >
                    <span className="py-[7px] md:pr-[10px] text-white">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke-width="1.5"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path className="path-white" d="M18.936,20.625H5.064a1.442,1.442,0,0,1-1.383-1.136l-2.138-9A1.484,1.484,0,0,1,2.926,8.625H21.074a1.484,1.484,0,0,1,1.383,1.864l-2.138,9A1.442,1.442,0,0,1,18.936,20.625Z" fill="none" stroke-linecap="round" stroke-linejoin="round" />
                            <path className="path-white" d="M4.5 8.625L9 3.375" fill="none" stroke-linecap="round" stroke-linejoin="round" />
                            <path className="path-white" d="M19.5 8.625L15 3.375" fill="none" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>

                    <span className="hidden md:block pr-3">{t("cart")}</span>
                    <div className="hidden md:flex justify-center items-center bg-white text-indigo-500 px-2  min-w-6 leading-normal " style={{ borderRadius: '5px' }}>
                        {carts.length}
                    </div>
                </div>
            </div>
            <Modal
                show={modalShow}
                size="5xl"
                popup={true}
                onClose={() => setModalShow(false)}
            >
                <Modal.Header className="pl-7 pt-5 pb-5 pr-7 text-gray-200" style={{ fontFamily: 'Inter' }}>{t("cart")}</Modal.Header>
                <hr />
                <Modal.Body>
                    {(setCartItemActiveState || getProductsByFilterState) && <Loading />}
                    <div className="py-6">
                        <div>
                            <div
                                className="overflow-x-auto overflow-y-auto relative sm:rounded-lg"
                                style={{ maxHeight: "70vh" }}
                            >
                                <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                    <tbody>
                                        {carts && carts.length > 0 ? (
                                            carts.map((data, index) => (
                                                <CartItem key={data._id} data={data} pos={index} />
                                            ))
                                        ) : (
                                            <></>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            {
                                carts && carts.length > 0 ? <></> :
                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                        {/* <img alt={'nodata'} style={{width:'150px'}} src="/nodata1.jpg"/> */}

                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" 
                                            viewBox="0 0 100 100" className="mt-4 mr-1" style={{width:'120px'}}>

                                            <path className="st0" d="M10,50c0,22.1,17.9,40,40,40s40-17.9,40-40S72.1,10,50,10S10,27.9,10,50z" />
                                            <path className="st1" d="M38.4,74.8c0,1,6.3,1.7,14.1,1.7s14.1-0.8,14.1-1.7l0,0c0-1-6.3-1.7-14.1-1.7S38.4,73.8,38.4,74.8z" />
                                            <path className="st1" d="M33.3,63.4c0,3,2.4,5.4,5.4,5.4h31.9c1.2,0,2.1-1,2.1-2.2c0-1.1-0.9-2.1-2.1-2.1H38.6c-0.6,0-1.1-0.5-1.1-1.1
	                                            c0-0.4,0.2-0.8,0.5-1l7-4.1c1-0.6,1.3-1.9,0.8-2.9S44,54.1,43,54.7l0,0l-7,4.1C34.3,59.8,33.3,61.5,33.3,63.4z"/>
                                            <path className="st2" d="M33.3,63.4c0,3,2.4,5.4,5.4,5.4h31.9c1.2,0,2.1-1,2.1-2.2c0-1.1-0.9-2.1-2.1-2.1H38.6c-0.6,0-1.1-0.5-1.1-1.1
	                                            c0-0.4,0.2-0.8,0.5-1l7-4.1c1-0.6,1.3-1.9,0.8-2.9S44,54.1,43,54.7l0,0l-7,4.1C34.3,59.8,33.3,61.5,33.3,63.4z"/>
                                            <path className="st3" d="M64.6,71.6c0,1.6,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0,0,0,0,0,0c0-1.6-1.3-2.8-2.8-2.8S64.6,70,64.6,71.6
	                                            C64.6,71.6,64.6,71.6,64.6,71.6z"/>
                                            <path className="st3" d="M37.9,71.6c0,1.6,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0,0,0,0,0,0c0-1.6-1.3-2.8-2.8-2.8S37.9,70,37.9,71.6
	                                            C37.9,71.6,37.9,71.6,37.9,71.6z"/>
                                            <path className="st4" d="M28.5,27.6v4.2h3c0.6,0,1.2,0.4,1.4,1.1l6.8,21.6c0.5,2.3,2.5,3.9,4.8,3.9H67c2.3,0,4.3-1.6,4.8-3.9l2.8-12.1
	                                            c0.6-2.7-1.1-5.3-3.7-5.9c-0.2,0-0.4-0.1-0.5-0.1l-32.9-3.8l-1.1-3.4c-0.2-0.9-1.1-1.6-2.1-1.6L28.5,27.6z M53.3,44.9
	                                            c-0.6,0-1-0.4-1-1v-4.1c0-0.6,0.4-1,1-1c0,0,0.1,0,0.1,0l4,0.5c0.5,0.1,0.9,0.5,0.9,1v3.6c0,0.6-0.4,1-1,1H53.3z M57.3,49.2
	                                            c0.6,0,1,0.4,1,1v3c0,0.6-0.4,1-1,1h-4c-0.6,0-1-0.4-1-1v-3c0-0.6,0.4-1,1-1H57.3z M70.4,41.6l-0.6,2.6c-0.1,0.5-0.5,0.8-1,0.8h-5.3
	                                            c-0.6,0-1-0.4-1-1V41c0-0.6,0.4-1,1-1c0,0,0.1,0,0.1,0l6.2,0.7C70.2,40.7,70.5,41.1,70.4,41.6C70.5,41.5,70.5,41.5,70.4,41.6
	                                            L70.4,41.6z M67.7,53.6c-0.1,0.3-0.4,0.6-0.7,0.6h-3.4c-0.6,0-1-0.4-1-1v-3c0-0.6,0.4-1,1-1h3.9c0.6,0,1,0.4,1,1c0,0.1,0,0.1,0,0.2
	                                            L67.7,53.6z M44.4,54.2c-0.2,0-0.4-0.1-0.4-0.3l-1-3.5c-0.2-0.5,0.1-1.1,0.7-1.2c0.1,0,0.2,0,0.3,0H47c0.6,0,1,0.4,1,1v3
	                                            c0,0.6-0.4,1-1,1H44.4z M39.4,38.6c-0.2-0.5,0.1-1.1,0.7-1.2c0.1,0,0.3-0.1,0.4,0l6.6,0.7c0.5,0.1,0.9,0.5,0.9,1v4.8
	                                            c0,0.6-0.4,1-1,1h-5c-0.4,0-0.8-0.3-1-0.7L39.4,38.6z"/>
                                            <path className="st1" d="M22,29.8c0-1.2,1-2.1,2.1-2.1h4.4v4.2h-4.4C23,31.9,22,30.9,22,29.8z" />
                                            <path className="st2" d="M28.5,27.6v4.2h3c0.6,0,1.2,0.4,1.4,1.1l6.8,21.6c0.5,2.3,2.5,3.9,4.8,3.9H67c2.3,0,4.3-1.6,4.8-3.9l2.8-12.1
                                                c0.6-2.7-1.1-5.3-3.7-5.9c-0.2,0-0.4-0.1-0.5-0.1l-32.9-3.8l-1.1-3.4c-0.2-0.9-1.1-1.6-2.1-1.6L28.5,27.6z M53.3,44.9
                                                c-0.6,0-1-0.4-1-1v-4.1c0-0.6,0.4-1,1-1c0,0,0.1,0,0.1,0l4,0.5c0.5,0.1,0.9,0.5,0.9,1v3.6c0,0.6-0.4,1-1,1H53.3z M57.3,49.2
                                                c0.6,0,1,0.4,1,1v3c0,0.6-0.4,1-1,1h-4c-0.6,0-1-0.4-1-1v-3c0-0.6,0.4-1,1-1H57.3z M70.4,41.6l-0.6,2.6c-0.1,0.5-0.5,0.8-1,0.8h-5.3
                                                c-0.6,0-1-0.4-1-1V41c0-0.6,0.4-1,1-1c0,0,0.1,0,0.1,0l6.2,0.7C70.2,40.7,70.5,41.1,70.4,41.6C70.5,41.5,70.5,41.5,70.4,41.6
                                                L70.4,41.6z M67.7,53.6c-0.1,0.3-0.4,0.6-0.7,0.6h-3.4c-0.6,0-1-0.4-1-1v-3c0-0.6,0.4-1,1-1h3.9c0.6,0,1,0.4,1,1c0,0.1,0,0.1,0,0.2
                                                L67.7,53.6z M44.1,54.1L43,50.4c-0.2-0.5,0.1-1.1,0.7-1.2c0.1,0,0.2,0,0.3,0H47c0.6,0,1,0.4,1,1v3c0,0.6-0.4,1-1,1h-2.6
                                                C44.3,54.2,44.2,54.2,44.1,54.1L44.1,54.1z M39.4,38.6c-0.2-0.5,0.1-1.1,0.7-1.2c0.1,0,0.3-0.1,0.4,0l6.6,0.7c0.5,0.1,0.9,0.5,0.9,1
                                                v4.8c0,0.6-0.4,1-1,1h-5c-0.4,0-0.8-0.3-1-0.7L39.4,38.6z"/>
                                            <path className="st2" d="M22,29.8c0-1.2,1-2.1,2.1-2.1h4.4v4.2h-4.4C23,31.9,22,30.9,22,29.8z" />
                                            <path className="st2" d="M54.6,31.9c1.2-4.3,4.8-6.5,7.3-7.3c2.5-0.7,5.8-0.3,6.7,2.1c0.8,2.1-1.1,4.7-3.3,4.8c-2.3,0-4.4-1.5-5-3.8
	                                            c-1.8-6.4,3-12.5,9.2-13.5"/>
                                            <path className="st2" d="M78.7,4.6c1.3-2,0.7-2.5-0.2-2.6" />
                                            <path className="st2" d="M79.6,5.4c2-1.3,2.5-0.7,2.6,0.2" />
                                            <path className="st3" d="M75,6.7c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5C76.1,4.3,75,5.4,75,6.7z" />
                                            <path className="st3" d="M73.3,14.4c0,1.9,1.5,3.4,3.4,3.4s3.4-1.5,3.4-3.4s-1.5-3.4-3.4-3.4S73.3,12.5,73.3,14.4z" />
                                            <path className="st3" d="M66.4,7.4c0,1.9,1.5,3.4,3.4,3.4s3.4-1.5,3.4-3.4S71.7,4,69.8,4S66.4,5.5,66.4,7.4z" />
                                            <path className="st5" d="M75.4,13.7c-0.8,0.8-3.7,1.4-5,1.2c-0.6-0.1-1-0.5-1.1-1.1c-0.2-1.3,0.4-4.2,1.2-5c1.2-1.2,3.9-1.7,5.2-0.3
                                                S76.5,12.5,75.4,13.7z"/>
                                            <path className="st2" d="M71.3,8.2l4.6,4.6" />
                                            <path className="st2" d="M70,9.7l4.5,4.5" />
                                        </svg>

                                    </div>
                            }
                        </div>
                    </div>
                </Modal.Body>
                <hr />
                <Modal.Footer>
                    <div style={{ minWidth: '100%', display: 'flex', justifyContent: 'space-around', alignItems: 'center', flexWrap: 'wrap' }} >
                        <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', flexWrap: 'wrap' }}>
                            <div className="mr-3 mt-3">
                                <Button
                                    color={"red"}
                                    onClick={() => setActive()}
                                    className="bg-green-100 text-green-500 hover:bg-green-200"
                                >
                                    {/* <HiOutlineCheckCircle className="mr-2 h-5 w-5" /> */}
                                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5" className="mr-2 h-5 w-5">
                                        <path d="M6,13.223,8.45,16.7a1.049,1.049,0,0,0,1.707.051L18,6.828" fill="none" stroke="green" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M0.750 11.999 A11.250 11.250 0 1 0 23.250 11.999 A11.250 11.250 0 1 0 0.750 11.999 Z" fill="none" stroke="green" stroke-linecap="round" stroke-linejoin="round" /></svg>
                                    {t("set_active")}
                                </Button>
                            </div>
                            <div className="mr-3 mt-3">
                                <Button
                                    color={"red"}
                                    className="bg-red-100 text-red-500 hover:bg-red-300"
                                    onClick={() => setInActive()}
                                >
                                    {/* <AiOutlineCloseCircle className="mr-2 h-5 w-5" /> */}
                                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5" className="mr-2 h-5 w-5" >
                                        <path d="M15.182 8.818L8.818 15.181" fill="none" stroke="red" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M8.818 8.818L15.182 15.181" fill="none" stroke="red" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z" fill="none" stroke="red" stroke-linecap="round" stroke-linejoin="round" /></svg>
                                    {t("set_inactive")}
                                </Button>
                            </div>
                            <div className="mr-3 mt-3">
                                <Button
                                    color={"white"}
                                    className="bg-gray-200 text-sitetx-200 hover:bg-gray-400"
                                    onClick={() => emptyCart()}
                                >
                                    {/* <HiOutlineTrash className="mr-2 h-5 w-5" /> */}
                                    <svg xmlns="http://www.w3.org/2000/svg" className="mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5"><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M18.0576 22.3846H5.94219C5.48317 22.3846 5.04294 22.2023 4.71836 21.8777C4.39377 21.5531 4.21143 21.1129 4.21143 20.6538V5.07692H19.7883V20.6538C19.7883 21.1129 19.606 21.5531 19.2814 21.8777C18.9568 22.2023 18.5166 22.3846 18.0576 22.3846Z" /><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M9.40381 17.1923V10.2692" /><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M14.5962 17.1923V10.2692" /><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M0.75 5.07692H23.25" /><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M14.5962 1.61539H9.40386C8.94484 1.61539 8.50461 1.79774 8.18003 2.12232C7.85544 2.4469 7.6731 2.88713 7.6731 3.34616V5.07693H16.3269V3.34616C16.3269 2.88713 16.1446 2.4469 15.82 2.12232C15.4954 1.79774 15.0552 1.61539 14.5962 1.61539Z" /></svg>
                                    {t("empty_basket")}
                                </Button>
                            </div>
                        </div>
                        <div className="mr-3 mt-3">
                            <AddProductInToWineMenu closePrevModal={setModalShow} />
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ProductTable;